import { Button, Modal } from "react-bootstrap";
import "./CsplAlertModal.css";

const CsplAlertModal = ({
  show,
  onCancel,
  onProceed,
  message,
  buttonText = "PROCEED",
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered backdrop="static">
      <Modal.Header
        style={{
          backgroundColor: "#1f4e79",
          color: "white",
          padding: "5px 10px",
        }}
      >
        <Modal.Title>Alert</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        {/* <Button variant="secondary" onClick={onCancel}>
          CANCEL
        </Button> */}
        <Button
          variant="primary"
          onClick={onProceed}
          style={{ backgroundColor: "rgb(31, 78, 121)" }}
        >
          {buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CsplAlertModal;
